import React, { useState } from "react";
import { MapPin, Phone, Mail, Send, Instagram, Facebook } from "lucide-react";
import { toast } from "sonner";
import Marquee from "../components/Marquee";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { brand } from "../mock/mock";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const set = (f) => (e) => setForm((s) => ({ ...s, [f]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Merci de remplir tous les champs.");
      return;
    }
    const saved = JSON.parse(localStorage.getItem("rp_contact") || "[]");
    saved.push({ ...form, createdAt: new Date().toISOString() });
    localStorage.setItem("rp_contact", JSON.stringify(saved));
    toast.success("Message envoyé ! Je vous réponds très vite.");
    setForm({ name: "", email: "", message: "" });
  };

  const infos = [
    { icon: MapPin, label: "Adresse", value: brand.address },
    { icon: Phone, label: "Téléphone", value: brand.phone },
    { icon: Mail, label: "E-mail", value: brand.email },
  ];

  return (
    <div>
      <section className="bg-[#FFF6F9] py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <span className="font-body text-xs tracking-[0.35em] uppercase text-[#9D184C]">Rim Patisse</span>
          <h1 className="font-title text-4xl md:text-6xl text-[#3A2A30] mt-4">Contact</h1>
          <p className="font-body text-[#3A2A30]/70 mt-4 max-w-xl mx-auto">
            Une question, une envie ? Écrivez-moi, je serai ravie d'échanger avec vous.
          </p>
        </div>
      </section>

      <Marquee />

      <section className="max-w-6xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-title text-3xl text-[#3A2A30] mb-8">Mes coordonnées</h2>
            <div className="space-y-5">
              {infos.map((c, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-12 h-12 shrink-0 rounded-full bg-[#FFF6F9] border border-[#F3D9E2] flex items-center justify-center">
                    <c.icon className="text-[#9D184C]" size={22} />
                  </div>
                  <div>
                    <div className="font-body text-xs uppercase tracking-wide text-[#9D184C]">{c.label}</div>
                    <div className="font-body text-[#3A2A30] mt-1">{c.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex gap-3 mt-8">
              <a href={brand.social.instagram} target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full bg-[#9D184C] hover:bg-[#7A0F39] text-white flex items-center justify-center transition-colors duration-200">
                <Instagram size={20} />
              </a>
              <a href={brand.social.facebook} target="_blank" rel="noreferrer" className="w-11 h-11 rounded-full bg-[#9D184C] hover:bg-[#7A0F39] text-white flex items-center justify-center transition-colors duration-200">
                <Facebook size={20} />
              </a>
            </div>

            <div className="mt-8 rounded-2xl overflow-hidden border border-[#F3D9E2]">
              <iframe
                title="Carte"
                src="https://www.openstreetmap.org/export/embed.html?bbox=2.36%2C48.85%2C2.40%2C48.87&layer=mapnik"
                className="w-full h-64 border-0"
                loading="lazy"
              />
            </div>
          </div>

          <div className="bg-white rounded-2xl p-7 md:p-9 border border-[#F3D9E2] shadow-[0_10px_40px_rgba(157,24,76,0.10)] self-start">
            <h2 className="font-title text-3xl text-[#3A2A30] mb-6">Écrivez-moi</h2>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label className="font-body text-sm text-[#3A2A30]">Nom</Label>
                <Input value={form.name} onChange={set("name")} placeholder="Votre nom" className="bg-[#FFF6F9] border-[#F3D9E2]" />
              </div>
              <div className="space-y-2">
                <Label className="font-body text-sm text-[#3A2A30]">E-mail</Label>
                <Input type="email" value={form.email} onChange={set("email")} placeholder="vous@email.fr" className="bg-[#FFF6F9] border-[#F3D9E2]" />
              </div>
              <div className="space-y-2">
                <Label className="font-body text-sm text-[#3A2A30]">Message</Label>
                <Textarea value={form.message} onChange={set("message")} rows={5} placeholder="Votre message…" className="bg-[#FFF6F9] border-[#F3D9E2]" />
              </div>
              <Button type="submit" className="w-full bg-[#9D184C] hover:bg-[#7A0F39] text-white font-body uppercase tracking-wide rounded-full py-6 text-sm">
                <Send size={18} className="mr-2" /> Envoyer
              </Button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
